import { Typography } from "@mui/material";
import Container from "@mui/material/Container";
import styles from "./AboutUs.module.css";

const AboutUs = () => {
  return (
    <div className="Section" style={{paddingTop:"72px", marginBottom:"32px"}}>
      <Container maxWidth="lg" sx={{maxWidth:"1304px !important;" }}>
        <div className={styles.aboutUsContainer}>
          <div className={styles.aboutUsTitle}>ABOUT US</div>
          <div className={styles.aboutUsSubTitle}>
            Connect the <span>learners</span> and <span>teachers</span> of our Deen
          </div>

          <div className={styles.aboutUsDescription}>
            <p>
              Takbir is our proclamation of greatness of Allah SWT by learning
              and practicing the only accepted Deen (religion) for mankind.
            </p>
            <p>
              Takbir is a secured, simple and easy-to-use online learning
              platform for learners (knowledge seekers) and amazing Mu’allim
              (teachers) of our Deen.
            </p>
          </div>

        </div>
      </Container>
    </div>
  );
};

export default AboutUs;
